import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  Validators,
} from "@angular/forms";
import { NavParams } from "ionic-angular";
import { Subscription } from "rxjs";
import { CompanyDetails } from "../company-details";

@Component({
  selector: "workgroup-general-details",
  templateUrl: "workgroup-general-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WorkgroupGeneralDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => WorkgroupGeneralDetails),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkgroupGeneralDetails
  extends CompanyDetails
  implements ControlValueAccessor, OnDestroy, OnInit
{
  subscriptions: Subscription[] = [];

  constructor(protected fb: FormBuilder, protected navParams: NavParams) {
    super(fb);
    // create inner form
    this.innerFormGroup = this.fb.group({
      groupName: ["", Validators.required],
    });

    this.subscriptions.push(
      this.innerFormGroup.valueChanges.subscribe((value) => {
        console.log("Group changed");
        console.log(value);
        this.onChange(value);
        this.onTouched();
      })
    );
  }

  @Input()
  isEditMode: boolean = false;

  set value(value: any) {
    console.log("DID I GET HERE");
    console.log(value);
    this.innerFormGroup.patchValue(value);
  }

  ngOnInit() {}

  valid(control: string) {
    return this.innerFormGroup.get(control).valid;
  }

  touched(control: string) {
    return this.innerFormGroup.get(control).touched;
  }

  validate(_: FormControl) {
    return this.innerFormGroup.valid ? null : {};
  }

  ngOnDestroy() {}
  // this.showLocationType = !this.isEditMode;
}



// WEBPACK FOOTER //
// ./src/pages/company/company-details/workgroup-general-details/workgroup-general-details.ts